module.exports = __webpack_public_path__ + "img/chengdu-hongren.92b7b1d8.png";